/* ============================================================================
 * ErrorState.tsx - Error UI component for ProjectDataContext
 * ============================================================================ */

import React from 'react';
import { useSettings } from '@/features/settings/contexts/SettingsContext';

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

/**
 * Error state component displayed when project data fails to load
 */
export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  const { t } = useSettings();
  return (
    <div className="flex h-screen items-center justify-center bg-zinc-50 dark:bg-zinc-950">
      <div className="max-w-md text-center">
        <div className="mb-4 text-red-500">
          <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="mb-2 text-xl font-semibold text-zinc-900 dark:text-zinc-100">{t('Error Loading Project')}</h2>
        <p className="mb-4 text-sm text-zinc-600 dark:text-zinc-400">{error}</p>
        <button
          onClick={onRetry}
          className="rounded-md border border-zinc-300 px-4 py-2 text-sm font-medium text-zinc-700 transition-colors hover:bg-zinc-100 dark:border-zinc-700 dark:text-zinc-200 dark:hover:bg-zinc-800"
        >
          {t('Retry')}
        </button>
      </div>
    </div>
  );
};
